// FIND US WORLDWIDE — region accordion (single-open) + contact bio
// "Read more" toggle (multi, independent per contact).
// Selector scoped to .office-contact-readmore specifically — avoids
// colliding with other modules (e.g. article-author-bio.js) that
// also use a generic [data-toggle] attribute.

const regionItems = document.querySelectorAll('.region-item');

regionItems.forEach(function (item) {
  const trigger = item.querySelector('.region-trigger');
  trigger.addEventListener('click', function () {
    const isOpen = item.classList.contains('is-open');
    regionItems.forEach(function (otherItem) {
      otherItem.classList.remove('is-open');
    });
    if (!isOpen) {
      item.classList.add('is-open');
    }
  });
});

document.querySelectorAll('.office-contact-readmore[data-toggle]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const target = document.getElementById(btn.dataset.toggle);
    if (!target) return;
    const isExpanded = target.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    const label = btn.querySelector('[data-toggle-label]');
    if (label) label.textContent = isExpanded ? 'Read less' : 'Read more';
  });
});
